import { BaseApi } from '@/main/baseApi';
import { MODULE_API, NAME, API_ND_AREA, NdSklad, } from './constants';

class PROrdersPartsProvider extends BaseApi {
	constructor() {
		super(MODULE_API, NAME);
	}

	async getPartsList(brand: string, wearHouse: number) {
		return this.fetch(`/Servis/Ozakazka/GetPartsList?SkladOzn=${wearHouse}&HledejPodretezecNdNr=true&VyrobekndOzn=${brand}`);
	}
	async getConversionUnits(ndnr: string, skladOzn: number, VyrobekndOzn: string) {
		return this.fetch(`/${MODULE_API}/NdSklad/GetConversionUnitsForPart`, { ndnr, skladOzn, VyrobekndOzn });
	}
	async getisObsoletePartStock(partNumber: string, warehouseId: number | null, brand: string, quantity: number) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/GetIsObsoletePartStock?partNumber=${partNumber}&quantity=${quantity}&brand=${brand}&warehouseId=${warehouseId}&IsProrder=true`);
	}
}

export const apiProvider = new PROrdersPartsProvider();
